<template>
  <div class="row" :class="errorClass" v-if="displayField">
    <div class="col-md-4 col-lg-4 col-xl-3">
      <label class="h6 col-md-right text-right">
        <span v-html="label"></span> <br>
        <small class="text-black-50 h6 col-md-right text-right">{{labelSecondary}}</small>
      </label>
    </div>
    <div class="col-md-8 col-lg-8 col-xl-9">
      <div class="form-group clearfix"> 
        {{ options }}
        <div v-if="errorClass !== ''" class="alert alert-danger mt-1" role="alert">
        {{validationMessage()}}
      </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: [
    'label',
    'labelSecondary',
    'isRequired',
    'displayField',
    'errorClass',
    'options'
  ],
  data () {
    return {
      wordsRemaining: 150,
      textContent: '',
      wordCountWarning: ''
    }
  },
  created () {
    console.log('FieldLabel component options ', this.options)
  },
  methods: {

    getIsRequired: function(){
      return this.isRequired === "true" ? {required: 'required'} : ''
    },
    validationMessage: function () {
      this.errorClass = ''
    },
    checkWordsRemaining: function (event) {
      this.wordsRemaining = 150 - this.textContent.split(' ').length + 1
      if (this.wordsRemaining < 0) {
        this.wordCountWarning = 'word-count-exceeded'
      } else {
        this.wordCountWarning = ''
      }
      console.log('fieldUpdated end nominationContentcheckWordsRemaining 68 ', this.label, this.textContent, this.wordsRemaining, this.textContent.length , this.displayField )
      this.$emit('added150WordContent', {label: this.label, content: this.textContent, validated: this.wordsRemaining >= 0 && this.textContent.length > 0, displayField: this.displayField})
    }
  }
}
</script>

<style lang="less">
  .word-count-exceeded {
    border-color: red !important;
    background: lightyellow;
  }
  .small-word-count-exceeded {
    color: red !important;
    font-weight: bold;
  }
</style>


// WEBPACK FOOTER //
// src/components/FieldLabel.vue